import { apiClient } from "./client";

// ---------- Types ----------

export interface PageSommaire {
  identifiant: string;
  titre: string;
  categorie: string;
  resume: string;
  ordre: number;
}

export interface PageDocumentation extends PageSommaire {
  /** Corps de la page en markdown, sans son en-tête ni son titre. */
  contenu: string;
}

// ---------- API calls ----------

export async function listDocumentationPages(): Promise<PageSommaire[]> {
  const response = await apiClient.get<PageSommaire[]>("/documentation");
  return response.data;
}

export async function getDocumentationPage(
  identifiant: string
): Promise<PageDocumentation> {
  const response = await apiClient.get<PageDocumentation>(
    `/documentation/${encodeURIComponent(identifiant)}`
  );
  return response.data;
}
